import { render, staticRenderFns } from "./LiveTransplantRegistration.vue?vue&type=template&id=285667dc"
import script from "./LiveTransplantRegistration.vue?vue&type=script&lang=js"
export * from "./LiveTransplantRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports